import RouterWrapper from "./routes";

function App() {
  return (
    <div>
      <RouterWrapper />
    </div>
  );
}

export default App;
